import { InputProps } from '../../interfaces/input.interface'
import c from 'classnames'
import styles from './TextInput.module.scss'

const TextInputComponent = ({ type, id, name, placeholder, value, onChange, onBlur,  onError }: InputProps) => {
    return (
        <input
            type={type}
            id={id}
            name={name}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            className={c(styles.input, onError && styles.error)}
            onBlur={onBlur}
        />
    )
}

export default TextInputComponent
